/*
 * Decimal, Account Management App.
 * Copyright (C) 2008-2013 Decimal
 * mailto:contact AT decimal DOT co DOT in
 *
 * Account is Decimal software; you can not redistribute it.
 * any versions of the License.
 * License is private by the Decimal Foundation;
 *
 * Inc., 8th Floor, Tower – D, Pioneer Urban Square, Golf Course Ext Rd,
 * Sector 62, Gurugram, Haryana 122102
 */

import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor } from './http.interceptor';
import { HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  /**
   *
   * @param injector Initializes
   */
  constructor(private readonly injector: Injector) {}

  /**
   * intercept
   * @param req:
   * @param next:
   * @returns Observable<HttpEvent<any>>
   */
  intercept(req, next: HttpHandler) {
    return next.handle(req);
  }
}
